import { UserDetail, UserInfoModel, ProfileModel } from '@/app/shared/models';
import { HttpService } from '@/app/shared/services/http.service';
import { refsService as refs } from '@/app/shared/refs.service';
import { env } from '@/environments';
import { ChangePasswordModel } from '../../models/auth/change-password.model';
import { PermissionModel } from '../../models/auth/permission.model';

export class UserService extends HttpService {
  public async getUserInfo(): Promise<UserInfoModel> {
    const user = await this.get<UserInfoModel>(
      `${env.authUrl}/connect/userInfo`
    ).then(({ data }) => data);
    if (user.owner) user.owner = JSON.parse(user.owner as string);
    if (user.roles) user.roles = JSON.parse(user.roles as string);
    if (user.subject) {
      user.userId = refs.util.maskUuid(user.subject);
    }
    return user;
  }
  public async getUserById(Id: string): Promise<UserDetail> {
    return await this.get<UserDetail>(`${env.authUri}/Users/${Id}`).then(
      ({ data }) => data
    );
  }

  public async loadProfile(
    accountId: string,
    profileId: string
  ): Promise<ProfileModel> {
    return await this.get<ProfileModel>(
      `${env.authUri}/Profiles/${profileId}`,
      {
        headers: { tenantId: accountId },
      }
    ).then(({ data }) => data);
  }

  public async loadActionList(
    serviceApiUri: string
  ): Promise<PermissionModel[]> {
    // O endpoint de permissions só aceita consultas na v1
    serviceApiUri = `${serviceApiUri}/permissions/actions`
      .replace('/v2/', '/v1/')
      .replace('/v3/', '/v1/');
    return await this.get<PermissionModel[]>(serviceApiUri).then(
      ({ data }) => data
    );
  }

  public async loadPermissionList(
    serviceApiUri: string,
    profileId: string[]
  ): Promise<PermissionModel[]> {
    // O endpoint de permissions só aceita consultas na v1
    serviceApiUri = `${serviceApiUri}/permissions/Profiles`
      .replace('/v2/', '/v1/')
      .replace('/v3/', '/v1/');
    return await this.post<PermissionModel[], object>(
      serviceApiUri,
      profileId
    ).then(({ data }) => data);
  }

  public async changeUserPassword(
    userId: string,
    changePassword: ChangePasswordModel
  ): Promise<void> {
    return await this.put<void, {}>(
      `${env.authUri}/Users/${userId}/PasswordChange`,
      changePassword
    ).then(({ data }) => data);
  }
}
